import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0e340208"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "live-overlay-container",
    class: "grid-center"
};
const _hoisted_2 = { id: "live-overlay-main-container" };
const _hoisted_3 = { id: "live-overlay-title-container" };
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_StateSvg = _resolveComponent("StateSvg");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                    id: "live-overlay-icon",
                    src: _ctx.iconSrc,
                    alt: "icon"
                }, null, 8, _hoisted_4),
                _createElementVNode("p", null, _toDisplayString(_ctx.title), 1),
                _createVNode(_component_StateSvg, {
                    class: "align-right",
                    id: "live-close",
                    src: "svg/close.svg",
                    onClick: _ctx.onClose
                }, null, 8, ["onClick"])
            ]),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.body), {
                class: "live-component",
                onOnClose: _ctx.onClose
            }, null, 40, ["onOnClose"]))
        ])
    ]));
}
